import App from './App';
import { useEffect, useRef } from 'react';
import { ThemeProvider } from '@emotion/react';
import { StyledEngineProvider } from '@mui/material';
import { godzilla as theme } from './utils/theme/godzilla_light';
import { ThemeContext, useAuth, SnackbarProvider } from './contexts';
import { keyCloakConfig } from './constants';
import { BackdropComponent } from './components';

export const AppContainer = () => {
    const { init, isInitialized, keycloakLoading, isAuthenticated } = useAuth();
    const keycloakInit = useRef(false);

    useEffect(() => {
        if (keycloakInit.current) {
            return;
        }
        // ref for limiting infinite loading
        keycloakInit.current = true;
        init(keyCloakConfig);
    }, [init]);

    if (!isInitialized && keycloakLoading) {
        return <BackdropComponent showBackdrop={true} />
    }

    if (!isAuthenticated) {
        return <div />;
    }

    return (
        <StyledEngineProvider injectFirst>
            <ThemeContext.Provider value={{ currentTheme: theme }}>
                <ThemeProvider theme={theme}>
                    <SnackbarProvider>
                        <App />
                    </SnackbarProvider>
                </ThemeProvider>
            </ThemeContext.Provider>
        </StyledEngineProvider>
    );
};